import { z } from 'zod'
import type { PaginatedResponse } from './common'

export const createCategorySchema = z.object({
  name_en: z.string().min(2).max(100),
  name_hi: z.string().min(2).max(100),
})

export const updateCategorySchema = createCategorySchema.partial()

export type CreateCategoryInput = z.infer<typeof createCategorySchema>
export type UpdateCategoryInput = z.infer<typeof updateCategorySchema>

export type CategoryResponse = {
  id: string
  name_en: string
  name_hi: string
  created_at: string
  updated_at: string
}

export type PublicCategoryResponse = {
  id: string
  name: string
}

export type CategorySortBy = 'created_at' | 'name_en' | 'name_hi'

export type PaginatedCategoryResponse = PaginatedResponse<CategoryResponse>
export type PaginatedPublicCategoryResponse =
  PaginatedResponse<PublicCategoryResponse>
